import dynamic from "next/dynamic";

export const DynamicContent062 = dynamic(() => import("./Content062"), {
  suspense: true,
});
